import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=275f6c34&scoped=true"
import script from "./Tips.vue?vue&type=script&setup=true&lang=js"
export * from "./Tips.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Tips.vue?vue&type=style&index=0&id=275f6c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275f6c34",
  null
  
)

export default component.exports